export default __webpack_public_path__ + "static/WINGBOT_logo_BLACK-COLOR-387bc195afe7689d6ab143f7edc0b388.png";